import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { API_URL } from "../../../constants";
import useAxios from "../../../hooks/useAxios";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import BeatLoader from "react-spinners/BeatLoader";
import { toast } from "react-hot-toast";

const PhonNumber = ({ setStep ,phoneNumber,setPhoneNumber}) => {
  const { control, handleSubmit, formState: { errors, isValid } } = useForm({
    mode: "onTouched",
    reValidateMode: "onTouched"
  });
  const [loading,setloading]=useState(false)
  const sendPhone =()=>{
    setloading(true)
    axios({
      method: "get",
      url:  `${API_URL}/sanctum/csrf-cookie`
    }).then(function(res) {
      axios({
        method: "post",
        url: `${API_URL}/api/auth/phone/`,
        data: phoneNumber,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(res) {
          if(res.data.message === "UserPanel Exist in system"){
            setloading(false)
            setStep(2)
          }
        })
        //
        .catch(function(err) {
          if(err.response.data.message === "UserPanel does not exist in system, Please Register"){
            setStep(3)
            toast.error( "این کاربر در سیستم وجود ندارد،لطفا ثبت نام کنید.")
          }
          setloading(false)
        });
    });
  }
  useEffect(
    () => {
      if (phoneNumber) {
        sendPhone()
      }
    },
    [phoneNumber]
  );

  const onSubmit = data => {
    setPhoneNumber(data);
    console.log(data);
  };

  return (
    <div>
      <h2>ورود و ثبت نام</h2>
      <p className="register-sub">
        با شماره تماس خود وارد وبسایت شوید و آنلاین اقامتگاه رزرو کنید و یا
        اقامتگاه خود را اجاره دهید
      </p>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="PhonNumber-input">
          <Input
            name="phone"
            control={control}
            errors={errors}
            register={{
               required: {
                 value: true,
                 message: "شماره تماس خود را وارد کنید"
               },
              pattern: {
               value: /^\(?([0-9]{4})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                message:
               " فرمت درست(۱۲۱۲ ۱۲۳ ۰۹۱۳) شماره تماس وارد شده اشتباه است!",
              }
            }}
            type="number"
            className="PhoneRegister__box-input"
            placeholder=" شماره تماس خود را وارد کنید"
          />
          <div className="PhonNumber-input-zipcode">+98 </div>
        </div>
        <Button varient="primary" fullwidth disabled={loading}>
          {loading ?  <BeatLoader
        
       color="#36d7b7"
        size={10}
        aria-label="Loading Spinner"
        data-testid="loader"
      />:"تایید شماره و ورود"}
        </Button>
      </form>
      <p className="rules">
        ورود شما به معنای پذیرش <span>قوانین</span> حریم خصوصی و شرایط{" "}
        <span>جاتیک</span> می باشد .
      </p>
    </div>
  );
};

export default PhonNumber;
